export const play_store_chart_tr = {
  "FREE": "Ücretsiz",
  "PAID": "Ücretli",
  "GROSSING": "Yüklesen",
};
